import { request } from "../../../services/api.ts"
import type { PerformanceQuery, TeamPerformanceResponse } from "./types"

export class PerformanceLoadError extends Error {
  constructor(public status?: number) {
    super("Performance data could not be loaded.")
  }
}

// apisauce resolves on every HTTP status; unwrap so callers get data or a throw.
export const fetchTeamPerformance = async ({
  grain,
  period,
  role,
  projectType
}: PerformanceQuery): Promise<TeamPerformanceResponse> => {
  const response = await request.api.get<TeamPerformanceResponse>(
    "/dashboard/team-performance/",
    {
      grain,
      role,
      ...(period ? { period } : {}),
      ...(projectType ? { project_type: projectType } : {})
    }
  )
  if (!response.ok || !response.data) {
    throw new PerformanceLoadError(response.status)
  }
  return response.data
}
